import type { MenuSection } from '@botto/core';

export const menu: MenuSection = {
  id: 'cdp',
  title: 'CDP',
  icon: 'group',
  items: [
    { title: 'Проекты', to: '/cdp/projects', icon: 'folder' },
    { title: 'События', to: '/cdp/events', icon: 'event' },
    { title: 'Контакты', to: '/cdp/contacts', icon: 'user' },
    { title: 'Типы событий', to: '/cdp/event-types', icon: 'detailslayout' },
    { title: 'Retention-правила', to: '/cdp/rules', icon: 'rules' },
    { title: 'Retention', to: '/cdp/retention', icon: 'clock' },
  ],
};
